<template>
  <b-card>
    <div v-if="loading" class="text-center">
      <b-spinner class="mt-2" variant="secondary" large />
    </div>

    <template v-else>
      <!-- Header -->
      <div class="d-flex align-items-center mb-2">
        <div class="avatar-circle mr-2">
          <feather-icon icon="FlagIcon" class="avatar-icon" />
        </div>
        <div class="flex-grow-1">
          <div class="text-muted font-small-3 mb-0">Total OKR</div>
          <h5 class="font-weight-bolder mb-0">{{ okrTotal | toCurrency }}</h5>
        </div>
      </div>

      <div class="block-divider my-2"></div>

      <!-- KPI grid -->
      <div class="kpi-grid">
        <div class="kpi-row" v-for="item in kpis" :key="item.key">
          <div class="kpi-label">{{ item.label }}</div>
          <div class="kpi-value"><b>{{ item.value }}</b></div>
        </div>
      </div>
      <div class="mt-1">
        <label>Obs: Valores serão recalculados após salvar o registro de algum PN</label>
      </div>
    </template>
  </b-card>
</template>

<script>
import { BCard, BSpinner } from 'bootstrap-vue'
import FeatherIcon from '@core/components/feather-icon/FeatherIcon.vue'
import { mapGetters } from 'vuex'
import * as types from '../store/types'

export default {
  components: { BCard, BSpinner, FeatherIcon },
  props: { loading: { type: Boolean, default: false } },
  computed: {
    ...mapGetters({ totalizer: types.PLANNED_OKR_TOTALIZER }),

    totalEpConsultantCommissionAmount() {
      return this.totalizer ? this.totalizer.total_ep_consultant_commission_amount : 0
    },
    krEpAmount() {
      return this.totalizer?.total_okr_ep_amount || 0

    },
    krEpQuantity() {
      return this.totalizer?.total_okr_ep_quantity || 0
    },
    epGoal() {
      return this.totalizer?.total_goal_ep_amount || 0
    },
    krEfQuantity() {
      return this.totalizer?.total_okr_ef_quantity || 0
    },
    krEaQuantity() {
      return this.totalizer?.total_okr_ea_quantity || 0
    },
    krLeadQuantity() {
      return this.totalizer?.total_okr_lead_quantity || 0
    },
    krHotLeadQuantity() {
      return this.totalizer?.total_okr_hot_lead_quantity || 0
    },
    totalSubscriptionsAmount() {
      return this.totalizer?.total_subscriptions_amount || 0
    },
    totalFinancialSolutionsAmount() {
      return this.totalizer?.total_financial_solutions_amount || 0
    },
    totalMxaAmount() {
      return this.totalizer?.total_mxa_quantity || 0
    },
    totalPaAmount() {
      return this.totalizer?.total_pa_quantity || 0 
    },
    okrTotal() {
      return this.totalizer?.total_okr_amount || 0 
    },

    // single source of truth for the list
    kpis() {
      return [
        { key: 'okrProLabore', label: 'OKR Pró-labore EP', value: this.$options.filters?.toCurrency?.(this.totalEpConsultantCommissionAmount) || this.totalEpConsultantCommissionAmount },
        { key: 'krLead',       label: 'KR 1 - Leads',        value: this.krLeadQuantity },
        { key: 'krLeadHot',    label: 'KR de Leads Quentes', value: this.krHotLeadQuantity },
        { key: 'krEa',         label: 'KR 2 - EA',          value: this.krEaQuantity },
        { key: 'krEf',         label: 'KR 6 - EF',          value: this.krEfQuantity },
        { key: 'krEp',         label: 'KR 3 - EP',          value: this.krEpQuantity },
        { key: 'okrEpR$',      label: 'KR EP (R$)',    value: this.$options.filters?.toCurrency?.(this.krEpAmount) || this.krEpAmount },
        { key: 'epGoal',       label: 'Meta de EP',    value: this.$options.filters?.toCurrency?.(this.epGoal) || this.epGoal },
        { key: 'okrAss',       label: 'KR Assinatura', value: this.$options.filters?.toCurrency?.(this.totalSubscriptionsAmount) || this.totalSubscriptionsAmount },
        { key: 'okrSol',       label: 'KR Soluções',   value: this.$options.filters?.toCurrency?.(this.totalFinancialSolutionsAmount) || this.totalFinancialSolutionsAmount },
        { key: 'okrMxa',       label: 'KR MXA',        value: this.totalMxaAmount },
        { key: 'okrPa',        label: 'KR PA',         value: this.totalPaAmount },
      ]
    },
  },
}
</script>

<style lang="scss">
/* Avatar: fixed, not 100% width */
.avatar-circle {
  width: 40px;
  height: 40px;
  border: 1px solid #ccc;
  border-radius: 50%;
  background-color: #9D9029;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 40px;
}
.avatar-icon {
  width: 18px;
  height: 18px;
  color: #B9BF3B;
}

/* Divider respects dark mode */
.block-divider {
  width: 100%;
  height: 1px;
  background-color: #dcdcdc;
}
.dark-layout .block-divider { background-color: #1b2132; }

/* KPI grid: responsive two-column label/value */
.kpi-grid {
  display: grid;
  grid-template-columns: 1fr auto;
  gap: 8px 12px;
}
.kpi-row { display: contents; } /* let children participate in grid */
.kpi-label { white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
.kpi-value { text-align: right; }

/* Tighten on small screens, scale up slightly on md+ */
@media (max-width: 575.98px) {
  .kpi-grid { gap: 6px 10px; }
}
@media (min-width: 768px) {
  .kpi-label { font-size: 0.95rem; }
  .kpi-value { font-size: 1rem; }
}
</style>
